import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import agent from "../../app/api/agent";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { setBasket } from "../basket/basketSlice";
import CheckoutPage from "./CheckoutPage";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe("pk_live_51O4VrtF3XDM5KcTq5Q3KuBjIMdPx0TwGotc2PCdErXLWT44KmCRNa70hb10dzteYKO6ReDMdPdTR4D0E89Gbp5iz00Z6zv7fAU")  // publishable key

export default function CheckoutWrapper() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [loading, setLoading] = useState(true)
    const [noEnoughItem, setNoEnoughItem] = useState<string>()

    const {basket} = useAppSelector(state => state.basket)
   

    // check quantiy in stock
    if (basket !== null) 
    {
        for (let i = 0; i < basket.items.length; i++) {
          agent.Catalog.details(basket.items[i].productId)
          .then((product) => {
            if (product.quantityInStock < basket.items[i].quantity)
            {   
                setNoEnoughItem(basket.items[i].name)
            }
          })
          if (noEnoughItem) break
        }
    }
    

    useEffect(() => {
        
        agent.Payments.createPaymentIntent(false, false, 'Courier Post') // assume not rural at first
            .then(basket => dispatch(setBasket(basket)))
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }, [dispatch])
    
    
    if (noEnoughItem) return (
      <>
        <Typography variant="h6" sx={{mb: 2}}> Sorry, the quantity of {noEnoughItem} in stock is not enough, please adjust your items in your cart.</Typography>
        <Button variant="contained" size='large' onClick={() => navigate('/basket')}>Go to cart</Button>
      </>
    )
    
    if (loading) return <LoadingComponent message="Loading checkout..." />

    return (

        <Elements stripe={stripePromise}>
            <CheckoutPage />
        </Elements>
    )
}